import {
  Building2,
  Lock,
  Trees,
  Zap,
  Droplets,
  Wifi,
  Dumbbell,
  Users,
} from "lucide-react";

const CommunitySnapshot = () => {
  const features = [
    {
      icon: Building2,
      title: "15 Towers",
      description: "729 apartments across 10.5 acres",
    },
    {
      icon: Lock,
      title: "24/7 Security",
      description: "CCTV surveillance, smart card access, video door phones",
    },
    {
      icon: Trees,
      title: "Green Spaces",
      description: "Landscaped gardens, maze garden, jogging track",
    },
    {
      icon: Zap,
      title: "100% Power Backup",
      description: "Uninterrupted electricity for lifts, pumps, 3000W per apartment",
    },
    {
      icon: Droplets,
      title: "Water Management",
      description: "Reliable water supply system with management infrastructure",
    },
    {
      icon: Wifi,
      title: "High-Speed Internet",
      description: "Integrated connectivity infrastructure throughout community",
    },
    {
      icon: Dumbbell,
      title: "Premium Amenities",
      description: "Swimming pool, wave pool, gymnasium, clubhouse, sports courts",
    },
    {
      icon: Users,
      title: "2000+ Residents",
      description: "Vibrant, established community with professional management",
    },
  ];

  return (
    <section id="community" className="py-20 sm:py-32 bg-gradient-to-b from-white via-blue-50 to-white">
      <div className="section-container">
        <div className="mb-20">
          <h2 className="text-5xl sm:text-6xl font-bold text-slate-900 mb-6 tracking-tight">Community Snapshot</h2>
          <p className="text-xl text-slate-600 font-light max-w-3xl">
            Comprehensive amenities and facilities for modern living
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={index}
                className="group bg-white border border-slate-200 rounded-2xl p-8 shadow-md hover:shadow-xl hover:border-blue-500 transition-all duration-300 transform hover:-translate-y-2 bg-gradient-to-br from-white to-slate-50 hover:to-blue-50"
              >
                <div className="mb-6 inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-blue-100 to-blue-200 rounded-xl group-hover:from-blue-200 group-hover:to-blue-300 transition-all duration-300 transform group-hover:scale-110 shadow-sm">
                  <Icon className="w-8 h-8 text-blue-700 transition-transform duration-300" />
                </div>
                <h3 className="font-bold text-xl text-slate-900 mb-4 transition-colors duration-300">
                  {feature.title}
                </h3>
                <p className="text-base text-slate-600 transition-colors duration-300 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CommunitySnapshot;
